import { useState } from "react";
import { useAuth } from "../contexts/AuthProvider";

const Login = () => {
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const { login }: any = useAuth();

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value)
    };

    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value)
    };

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        console.log(email, password)
        try {
            setErrorMsg("");
            setLoading(true);
            if (password === '' || email === '') {
                setErrorMsg("Please fill in the fields");
                return;
            }
            const {
                data: { user, session },
                error
            } = await login(email, password);
            if (error) setErrorMsg(error.message);
        } catch (error) {
            setErrorMsg("Email or Password Incorrect");
        }
        setLoading(false);
    };

    return (
        <>
            <div className="grid card rounded-box ">
                <div className="px-4 py-5 sm:p-6">
                    <h2 className="text-center text-2xl font-bold mb-4">Login</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div id="email">
                            <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2">Email</label>
                            <input type="email" onChange={handleEmailChange} required className="input input-bordered w-full pl-4 bg-white" />
                        </div>
                        <div id="password">
                            <label htmlFor="password" className="block text-sm font-bold mb-2">Password</label>
                            <input type="password" onChange={handlePasswordChange} required className="input input-bordered w-full pl-4 bg-white" />
                        </div>
                        {errorMsg && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                                <strong className="font-bold">Error</strong>
                                <span className="block sm:inline"> {errorMsg}</span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3" onClick={() => setErrorMsg("")}>
                                    <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" /></svg>
                                </span>
                            </div>
                        )}
                        <div className="text-center mt-2">
                            <button disabled={loading} type="submit" className="w-1/2 text-xl font-semibold p-2 btn-primary rounded-full mt-4 md:mt-auto items-center justify-center">
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;